import { render, staticRenderFns } from "./GhostIdentity.vue?vue&type=template&id=6956adb2&scoped=true&"
import script from "./GhostIdentity.vue?vue&type=script&lang=js&"
export * from "./GhostIdentity.vue?vue&type=script&lang=js&"
import style0 from "./GhostIdentity.vue?vue&type=style&index=0&id=6956adb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956adb2",
  null
  
)

export default component.exports